import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import { EndpointKeys, Libraries } from '../../constants/utils/app.constants';
import { AuthAccessTokenDetails, OauthAEMConfig } from '../../models/login';
import {
  CommonRequest,
  PayloadRequest,
  StatusTrackerResponse
} from '../../models/status-tracker/api/api-status-tracker.interfaces';
import {
  COMMON_HEADER_KEY,
  commonHeaderInfo
} from '../../models/status-tracker/status-tracker.constants';
import { CustomError } from '../../models/utils';
import { AppTokenService } from '../login';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  logCustomError
} from '../utils';
import { ContentService } from './content.service';

@Injectable({
  providedIn: 'root'
})
export class StatusTrackerService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private appToken: AppTokenService,
    private content: ContentService
  ) {}

  getStatusTrackerResponse = (
    request: CommonRequest
  ): Observable<StatusTrackerResponse | undefined> => {
    return this.content.getAuthConfigContent().pipe(
      concatMap((authConfig: OauthAEMConfig) => {
        return this.appToken.getAppTokenWithParams(
          authConfig.CLIENT_ID_VALUE,
          authConfig.SCOPE_VALUE_RM
        );
      }),
      concatMap((token: AuthAccessTokenDetails) => {
        const payload: PayloadRequest = { carrierCode: request.carrierCode };
        commonHeaderInfo['X-Delta-DLCOM_Loyalty_App_Test'] = COMMON_HEADER_KEY;
        commonHeaderInfo['Authorization'] = token.access_token;
        if (request.carrierCode) {
          return new ApiBuilder<
            PayloadRequest,
            StatusTrackerResponse | CustomError
          >(this.http, this.appConfig)
            .app(IDP_APPS.SKYMILES)
            .endpointKey(
              EndpointKeys['SKYMILES_API_STATUS_TRACKER_MULTI_REGION']
            )
            .method(HttpRequestMethods['POST'])
            .payload(payload)
            .httpHeaders(commonHeaderInfo)
            .timeOut(request.timeout)
            .errorHandler(this.errorHandler)
            .retries(request.retry)
            .library(Libraries.OVERVIEW)
            .withCredentials(true)
            .create()
            .pipe(
              map((response: StatusTrackerResponse | CustomError) => {
                return this.existCustomError(response);
              })
            );
        }
        return of(undefined);
      })
    );
  };

  existCustomError(
    response: StatusTrackerResponse | CustomError
  ): StatusTrackerResponse {
    if ('errorResponse' in response) {
      logCustomError(
        response.errorResponse,
        IDP_APPS.SKYMILES,
        Libraries.OVERVIEW,
        EndpointKeys.SKYMILES_API_STATUS_TRACKER_MULTI_REGION
      );
      throw throwError(response);
    }
    return response;
  }
}
